class GuideHub extends HTMLElement {
  constructor() {
    super();
    this.filterButtons = [...this.querySelectorAll('[data-guide-filter]')];
    this.cards = [...this.querySelectorAll('[data-guide-card]')];
    this.count = this.querySelector('[data-guide-count]');
    this.empty = this.querySelector('[data-guide-empty]');
    this.activeCategory = 'all';
  }

  connectedCallback() {
    if (!this.cards.length) return;

    this.filterButtons.forEach((button) => {
      button.addEventListener('click', () => {
        this.activeCategory = button.dataset.guideFilter;
        this.filterButtons.forEach((item) => {
          const isActive = item === button;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
        this.update();
      });
    });

    this.update();
  }

  update() {
    let visible = 0;

    this.cards.forEach((card) => {
      const show =
        this.activeCategory === 'all' || card.dataset.guideCategory === this.activeCategory;
      card.hidden = !show;
      if (show) visible += 1;
    });

    if (this.count) {
      this.count.textContent = `${visible} ${visible === 1 ? 'guide' : 'guides'}`;
    }
    this.empty?.classList.toggle('is-visible', visible === 0);
  }
}

if (!customElements.get('guide-hub')) {
  customElements.define('guide-hub', GuideHub);
}
